// Tarjeta de preview reutilizable: cómo verá el asistente el evento.
import { Calendar, MapPin, Video } from "lucide-react";

type Props = {
  title: string;
  date: string;
  startTime: string;
  imageUrl?: string;
  isVirtual: boolean;
  location: string;
  city: string;
  fromPrice: number | null; // null = sin precio, 0 = gratis
};

export function EventPreviewCard({ title, date, startTime, imageUrl, isVirtual, location, city, fromPrice }: Props) {
  const dateLabel = date
    ? new Date(`${date}T${startTime || "00:00"}`).toLocaleDateString("es-CR", {
        weekday: "short", day: "numeric", month: "short",
      })
    : "Fecha";
  return (
    <article className="overflow-hidden rounded-2xl border border-border bg-card">
      <div className="relative aspect-[16/9] w-full">
        {imageUrl ? (
          <img src={imageUrl} alt="" className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-end gradient-primary p-4">
            <span className="text-2xl font-black text-primary-foreground line-clamp-2">{title || "Tu evento"}</span>
          </div>
        )}
      </div>
      <div className="space-y-1.5 p-4">
        <h3 className="text-lg font-bold text-card-foreground line-clamp-2">{title || "Nombre del evento"}</h3>
        <p className="flex items-center gap-1.5 text-sm text-muted-foreground">
          <Calendar className="h-4 w-4" /> {dateLabel} · {startTime}
        </p>
        <p className="flex items-center gap-1.5 text-sm text-muted-foreground">
          {isVirtual ? <><Video className="h-4 w-4" /> Evento virtual</> : <><MapPin className="h-4 w-4" /> {[location, city].filter(Boolean).join(", ") || "Lugar"}</>}
        </p>
        <p className="pt-1 text-sm font-bold text-primary">
          {fromPrice === null ? "" : fromPrice === 0 ? "Gratis" : `Desde ₡${fromPrice.toLocaleString("es-CR")}`}
        </p>
      </div>
    </article>
  );
}
